var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _rect4, _path5, _path6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetstartedPropound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 76,
    viewBox: "0 0 63 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.08643,
    y: 1.42773,
    width: 60.5458,
    height: 73.055,
    rx: 3,
    fill: "#F5FAF9",
    stroke: "#80A39C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63647,
    y: 11.3774,
    width: 11.111,
    height: 11.111,
    rx: 1.25,
    fill: "white",
    stroke: "#25656F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.156 15.7437L14.3107 19.3936",
    stroke: "#3ABE5F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3108 19.3936L21.5838 10.6275",
    stroke: "#3ABE5F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63647,
    y: 31.6484,
    width: 11.111,
    height: 11.111,
    rx: 1.25,
    fill: "white",
    stroke: "#25656F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2375 36.0146L14.3922 39.6646",
    stroke: "#3ABE5F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3923 39.6646L21.6654 30.8985",
    stroke: "#3ABE5F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63647,
    y: 50.9854,
    width: 11.111,
    height: 11.111,
    rx: 1.25,
    fill: "white",
    stroke: "#25656F",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.156 55.3516L14.3107 59.0016",
    stroke: "#3ABE5F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3108 59.0015L21.5838 50.2354",
    stroke: "#3ABE5F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7012,
    y: 12.3604,
    width: 30.9438,
    height: 3.25938,
    fill: "#CDCDCD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7012,
    y: 32.6318,
    width: 30.9438,
    height: 3.25938,
    fill: "#CDCDCD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7012,
    y: 52.2236,
    width: 30.9438,
    height: 3.25938,
    fill: "#CDCDCD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7012,
    y: 17.7354,
    width: 22.3029,
    height: 3.25938,
    fill: "#CDCDCD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7012,
    y: 38.0063,
    width: 12.6428,
    height: 3.25938,
    fill: "#CDCDCD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7012,
    y: 57.5986,
    width: 28.175,
    height: 3.25938,
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstartedPropound);
export default __webpack_public_path__ + "static/media/getstarted-propound.f187979dbc16a1cf0c6d3818b5521cf7.svg";
export { ForwardRef as ReactComponent };